import * as ViewModels from "./ViewModels/index.js";
/** CoStar.Api.CentralAuthentication.ChangePasswordFailReason */
export var ChangePasswordFailReason;
(function (ChangePasswordFailReason) {
    ChangePasswordFailReason[ChangePasswordFailReason["None"] = 0] = "None";
    ChangePasswordFailReason[ChangePasswordFailReason["InvalidCurrentPassword"] = 1] = "InvalidCurrentPassword";
    ChangePasswordFailReason[ChangePasswordFailReason["InvalidNewPassword"] = 2] = "InvalidNewPassword";
    ChangePasswordFailReason[ChangePasswordFailReason["Error"] = 3] = "Error";
})(ChangePasswordFailReason || (ChangePasswordFailReason = {}));
/** CoStar.Api.CentralAuthentication.SignInFailReason */
export var SignInFailReason;
(function (SignInFailReason) {
    SignInFailReason[SignInFailReason["None"] = 0] = "None";
    SignInFailReason[SignInFailReason["InvalidCredentials"] = 1] = "InvalidCredentials";
    SignInFailReason[SignInFailReason["InternalError"] = 2] = "InternalError";
    SignInFailReason[SignInFailReason["LockedOut"] = 3] = "LockedOut";
})(SignInFailReason || (SignInFailReason = {}));
export { ViewModels };
